import { render } from "./InputSwitch.vue?vue&type=template&id=4733901b"
import script from "./InputSwitch.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./InputSwitch.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__